import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { Layout } from '../components/Layout';
export function AboutPage() {
  return <Layout data-id="element-212">
      {/* Hero Section */}
      <section className="relative h-[40vh] md:h-[50vh] flex items-center justify-center overflow-hidden" data-id="element-213">
        <div className="absolute inset-0 z-0" data-id="element-214">
          <img src="https://cdn.magicpatterns.com/uploads/wmSkg482hFp8kjWmQevk6b/image.png" alt="About Us Background" className="w-full h-full object-cover brightness-[0.5]" data-id="element-215" />
          <div className="absolute inset-0 bg-black/20" data-id="element-216" />
        </div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="relative z-10 text-4xl md:text-6xl font-bold text-white uppercase tracking-tighter text-center" data-id="element-217">
          About Us
        </motion.h1>
      </section>

      {/* Main Content */}
      <section className="py-24 px-6 bg-white" data-id="element-218">
        <div className="max-w-7xl mx-auto" data-id="element-219">
          <div className="flex flex-col lg:flex-row gap-16 items-start mb-24" data-id="element-220">
            <div className="flex-1 space-y-8" data-id="element-221">
              <h2 className="text-4xl font-black text-[#6B0D24] uppercase tracking-tight" data-id="element-222">
                About Us
              </h2>
              <div className="space-y-6 text-charcoal/70 leading-relaxed text-lg" data-id="element-223">
                <p data-id="element-224">
                  NK Resurfacers has been servicing the community since 2003 and
                  working with accredited local manufacturers to eliminate the
                  added cost of third-party or middleman services. Our company
                  provides design consultation and installation for homeowner &
                  commercial clients.
                </p>
                <p data-id="element-225">
                  All of our efforts are devoted to one purpose; to deliver the
                  highest quality products with complete customer satisfaction,
                  guaranteed that you will find the greatest value in our
                  products and customer service.
                </p>
                <p data-id="element-226">
                  NK Resurfacers offers a wide variety of brand name cabinetry
                  and flooring to meet both residential and commercial needs,
                  from classic and elegant to sleek and contemporary.
                </p>
                <p data-id="element-227">
                  Our cabinet specialists are always ready to assist you in
                  designing a beautiful kitchen and choosing cabinets that fit
                  your life style and budget.
                </p>
              </div>
            </div>
            <div className="flex-1 w-full" data-id="element-228">
              <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} className="shadow-2xl border border-charcoal/5" data-id="element-229">
                <img src="https://cdn.magicpatterns.com/uploads/iTbvu3C4vkWTXNBvrVaCFr/about.png" alt="Modern Kitchen Design" className="w-full h-auto object-cover" data-id="element-230" />
              </motion.div>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-231">
            <div className="space-y-8" data-id="element-232">
              <h2 className="text-3xl font-black text-[#6B0D24] uppercase tracking-tight" data-id="element-233">
                Why You Should Choose Us
              </h2>
              <p className="text-charcoal/70 leading-relaxed" data-id="element-234">
                We understand that a home improvement project can be
                overwhelming to home owners and they may not know where to
                start. At NK Resurfacers, we provide the products for all your
                home renovation needs.
              </p>
              <ul className="space-y-4" data-id="element-235">
                {['In service since 2003', 'Experienced Staff', 'Quality Products'].map(item => <li key={item} className="flex items-center gap-3 text-charcoal/80 font-bold" data-id="element-236">
                    <CheckIcon size={20} className="text-[#6B0D24]" strokeWidth={3} data-id="element-237" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="space-y-8" data-id="element-238">
              <h2 className="text-3xl font-black text-[#6B0D24] uppercase tracking-tight" data-id="element-239">
                Guidelines For Choosing Cabinets
              </h2>
              <ul className="space-y-4" data-id="element-240">
                {['Exact measurement of appliances involved in the design', 'Duration of stay in the home', 'Layout desired', 'Standard improvements of similar homes in the area', 'Budget'].map(item => <li key={item} className="flex items-center gap-3 text-charcoal/80 font-bold" data-id="element-241">
                    <CheckIcon size={20} className="text-[#6B0D24]" strokeWidth={3} data-id="element-242" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>
    </Layout>;
}